import logo from "./logo.svg";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import "./App.css";
import Home from "./pages";
import WalletPage from "./pages/wallet";
import DepositPage from "./pages/wallet/deposit";
import WithDrawalPage from "./pages/wallet/withdrawal";
import ExchangePage from "./pages/exchange";
import TransactionPage from "./pages/transaction";
import ProfilePage from "./pages/profile";
import SettingsPage from "./pages/settings";
import SupportPage from "./pages/support";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/wallet" component={WalletPage} />
        <Route exact path="/wallet/deposit" component={DepositPage} />
        <Route exact path="/wallet/withdrawal" component={WithDrawalPage} />
        <Route exact path="/exchange" component={ExchangePage} />
        <Route exact path="/transaction" component={TransactionPage} />
        <Route exact path="/profile" component={ProfilePage} />
        <Route exact path="/settings" component={SettingsPage} />
        <Route exact path="/support" component={SupportPage} />
      </Switch>
    </Router>
  );
}

export default App;
